import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import CreateWhatsappIntentsService from '../Services/CreateWhatsappIntentsService.js'

class CreateWhatsappIntentsUserUseCase extends UseCase {
  #service

  constructor({service}) {
    super()
    this.#service = service
  }

  static create({config}) {
    return new CreateWhatsappIntentsUserUseCase({
      service: CreateWhatsappIntentsService.create({config})
    })
  }

  @tracer({metric: 'CreateWhatsappIntentsUserUseCase#execute'})
  @AsyncInlineError()
  async execute({resourceType = 'AD', resourceId}) {
    const [error, whatsappIntents] = await this.#service.execute({resourceType, resourceId})

    if (error) return Promise.reject(error)

    return whatsappIntents.value
  }
}

export const factory = CreateWhatsappIntentsUserUseCase.create
